import { render, staticRenderFns } from "./SampleEdit.vue?vue&type=template&id=2917b305"
import script from "./SampleEdit.vue?vue&type=script&lang=js"
export * from "./SampleEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports